import React from "react";
import StudentsList from "./StudentsList";

const ReportPdf = ({
  students,
  opportunities,
  timeLogs,
  activeFilters,
  metrics,
}) => {
  return (
    <div className="pdf-template p-8 pdf">
      <div className="bg-gray-100 rounded-xl p-6 mb-4 avoid-page-break">
        <div className="flex items-center gap-4 mb-4">
          <img
            src={`${process.env.PUBLIC_URL}/logo192.png`}
            alt="WBL Logo"
            className="w-12 h-12 object-contain rounded-lg"
          />
          <h1 className="text-2xl font-bold text-gray-900">
            WBL Students Report
          </h1>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {Object.entries(metrics).map(([key, data]) => (
            <div
              key={key}
              className="bg-white rounded-lg p-2 flex items-center avoid-page-break"
            >
              <div className={`p-3 rounded-full ${data.bgColor}`}>
                {React.createElement(data.icon, {
                  className: data.color,
                  size: 16,
                })}
              </div>
              <div className="ml-3">
                <p className="text-gray-500 text-xs font-medium">{key}</p>
                <p className="text-md font-bold text-gray-900">{data.value}</p>
              </div>
            </div>
          ))}
        </div>

        {activeFilters && activeFilters.length > 0 && (
          <div className="mt-4 flex gap-4 items-center avoid-page-break">
            <h2 className="text-md font-semibold mb-4">Applied Filters:</h2>
            <div className="flex flex-wrap gap-2">
              {activeFilters.map((filter, index) => (
                <span
                  key={index}
                  className="px-3 py-1 pb-4 bg-blue-100 text-blue-800 rounded-full text-sm"
                >
                  {filter}
                </span>
              ))}
            </div>
            <span className="text-sm text-gray-500 flex-grow text-right">
              {new Date().toLocaleDateString()}
            </span>
          </div>
        )}
      </div>

      <div className="rounded-xl avoid-page-break">
        <h2 className="text-xl font-semibold p-4 border-b">Students List</h2>
        <StudentsList
          students={students}
          opportunities={opportunities}
          timeLogs={timeLogs}
          isPDF={true}
        />
      </div>
    </div>
  );
};

export default ReportPdf;
